<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reload="resetPage"
        @openEditFormDialog="openEditFormDialog"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <EditForm
      :visible.sync="editFormDialogOptions.visible"
      :samplePropertiesImageCode="editFormDialogOptions.code"
      :disabled="editFormDialogOptions.disabled"
      :title="editFormDialogOptions.title"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import BasePage from '@/mixins/base-pagination'
import EditForm from '../edit-form'

export default {
  components: {
    PageHeader,
    PageMain,
    EditForm,
  },
  mixins: [BaseTable, BasePage],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .masterSamplePropertiesListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, code = '' }) {
      const types = {
        edit: this.$l('form_label_goods_edit') || '编辑产品特性信息',
        add: this.$l('form_label_goods_add') || '新增产品特性信息',
        detail: this.$l('form_label_goods_detail') || '费用信息详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        code: code,
        disabled: type === 'detail',
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
  },
}
</script>
